document.addEventListener("DOMContentLoaded", async () => {
    const shadowHost = await waitForElement('#ShopifyChat');

    if (shadowHost && shadowHost.shadowRoot) {
        // console.log('Shadow root found:', shadowHost);

        // Check once if the button is already there
        const chatToggleButton = shadowHost.shadowRoot.querySelector('.chat-toggle');
        if (chatToggleButton) {
            // console.log('Chat toggle button found immediately:', chatToggleButton);
            return; // No need to observe if we already found it
        }

        // If not found, observe for changes — but only once
        const observer = new MutationObserver(mutations => {
            const chatToggleButton = shadowHost.shadowRoot.querySelector('.chat-toggle');
            if (chatToggleButton) {
                // console.log('Chat toggle button found after mutation:', chatToggleButton);
                const csContactTrigger = document.querySelector('#csContactTrigger')
                csContactTrigger.addEventListener('click', () => {
                    chatToggleButton.click()
                })
                observer.disconnect(); // Stop observing once we find it
            }
        });

        observer.observe(shadowHost.shadowRoot, { childList: true, subtree: true });
    } else {
        // console.log('Shadow root not available or still empty.');
    }


    function waitForElement(selector, root = document) {
        return new Promise(resolve => {
            const element = root.querySelector(selector);
            if (element) return resolve(element);

            const observer = new MutationObserver(() => {
                const element = root.querySelector(selector);
                if (element) {
                    observer.disconnect();
                    resolve(element);
                }
            });

            observer.observe(root, { childList: true, subtree: true });
        });
    }

});